
import { defineComponent, ref, onBeforeMount } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiBase, ApiWarehouses } from "@/core/api";
import Swal from "sweetalert2/dist/sweetalert2.js";
import mixin from "@/mixins";
import { useI18n } from "vue-i18n";
import { TaggingItem } from "@/core/directive/interface/common";

export default defineComponent({
  name: "add-warehouses",
  components: {},
  emits: ["update-list", "reset-form"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const formRef = ref<null | HTMLFormElement>(null);
    const addWarehouses = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const loading = ref<boolean>(false);
    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();
    const options = ref({
      type: [] as TaggingItem[],
      function_type: [] as TaggingItem[],
    });
    const formData = ref({
      status: 10,
      code: "",
      name: "",
      short_code: "",
      type: "",
      function_type: "",
    });

    const countryOptions = ref([]);
    const parentCompanys = ref([]);
    const rules = ref({
      name: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      code: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      short_code: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      status: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      type: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      function_type: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          if (loading.value) return;
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiWarehouses.addWarehouse(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addWarehouses.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const getTaggingData = () => {
      ApiBase.getTaggingData({
        short_key: ["warehouse_type", "warehouse_function_type"],
      })
        .then(({ data }) => {
          if (data.code == 0) {
            options.value.type = data.data.warehouse_type.items;
            options.value.function_type =
              data.data.warehouse_function_type.items;
            // options.value.taggings = data.data.warehouse_taggings.items;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const getFromInfo = async () => {
      loading.value = true;
      Promise.all([getTaggingData()])
        .then(() => {
          loading.value = false;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleDiscard = () => {
      hideModal(addWarehouses.value);
      resetForm();
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    onBeforeMount(() => {
      getFromInfo();
    });

    return {
      t,
      loading,
      formData,
      rules,
      formRef,
      addWarehouses,
      submitButton,
      countryOptions,
      parentCompanys,
      options,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
